<div class="input-otp__container">
    <ng-container *ngFor="let otp of fields.otpFields; let i = index;">
        <form-inputtext class="{{otp.class}}"
                (keyup) = "changeValueCode($event, i); onDigitInput(otp.id)"
                [fields]="otp">
    </form-inputtext> 
    </ng-container>
</div>